import { render, staticRenderFns } from "./leed-platinum.en.vue?vue&type=template&id=5ad16982&"
import script from "./leed-platinum.en.vue?vue&type=script&lang=js&"
export * from "./leed-platinum.en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports